/* SpielzeugShop24 – Theme-JS Teil B: Kollektion (Filter/Sortierung), Empfehlungen, Sticky-Kaufleiste, Init.
   Setzt sps-theme.js (Teil A) voraus. */
(function () {
  'use strict';
  var SPS = window.SPS; if (!SPS || !SPS._) return;
  var $ = SPS._.$, $$ = SPS._.$$, on = SPS._.on, wishSync = SPS._.wishSync, Cart = SPS.cart;
  var initSearch = SPS._.initSearch, initTabs = SPS._.initTabs, initGallery = SPS._.initGallery, initVariants = SPS._.initVariants;

  /* ---------- Kollektion: Filter & Sortierung ---------- */
  function initCollection(root) {
    var form = $('form[data-sps-filters]', root); var sectionId = root.getAttribute('data-section-id'); var products = $('[data-sps-products]', root);
    var timer;
    function url(extra) {
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
      }
      var sort = $('[data-sps-sort]', root); if (sort && sort.value) params.set('sort_by', sort.value);
      if (extra) Object.keys(extra).forEach(function (k) { params.set(k, extra[k]); });
      var q = params.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }
    function load(href, push) {
      root.classList.add('is-loading'); if (products) products.classList.add('is-loading');
      var u = new URL(href, window.location.origin); u.searchParams.set('section_id', sectionId);
      fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sps-collection]'); if (!fresh) { window.location.href = href; return; }
        var wasOpen = $('.sps-filters.is-open', root);
        // Filter offen/zu übernehmen
        var openState = {}; $$('.sps-filter', root).forEach(function (d) { openState[d.getAttribute('data-key')] = d.open; });
        root.innerHTML = fresh.innerHTML;
        $$('.sps-filter', root).forEach(function (d) { if (openState.hasOwnProperty(d.getAttribute('data-key'))) d.open = openState[d.getAttribute('data-key')]; });
        if (wasOpen) { var f = $('.sps-filters', root); if (f) f.classList.add('is-open'); }
        bind();
        if (push) history.pushState({ sps: true }, '', href);
        root.classList.remove('is-loading');
        var top = root.getBoundingClientRect().top; if (top < 0) window.scrollTo({ top: window.pageYOffset + top - 120, behavior: 'smooth' });
      }).catch(function () { window.location.href = href; });
    }
    function bind() {
      form = $('form[data-sps-filters]', root); products = $('[data-sps-products]', root);
      if (form) {
        on(form, 'change', function (e) { if (e.target.type === 'number') return; clearTimeout(timer); timer = setTimeout(function () { load(url(), true); }, 60); });
        on(form, 'submit', function (e) { e.preventDefault(); load(url(), true); });
        $$('input[type=number]', form).forEach(function (i) { on(i, 'change', function () { clearTimeout(timer); timer = setTimeout(function () { load(url(), true); }, 400); }); });
        initRange(form);
        $$('.sps-filter__more', form).forEach(function (b) { on(b, 'click', function () { var list = b.previousElementSibling; list.classList.toggle('is-collapsed'); b.textContent = list.classList.contains('is-collapsed') ? b.getAttribute('data-more') : b.getAttribute('data-less'); }); });
      }
      var sort = $('[data-sps-sort]', root); on(sort, 'change', function () { load(url(), true); });
      $$('a[data-sps-ajax]', root).forEach(function (a) { on(a, 'click', function (e) { e.preventDefault(); load(a.getAttribute('href'), true); }); });
      var fb = $('[data-sps-filters-toggle]', root); var panel = $('.sps-filters', root); var bd = $('.sps-filters-backdrop', root);
      function toggle(o) { if (panel) panel.classList.toggle('is-open', o); if (bd) bd.classList.toggle('is-open', o); document.body.classList.toggle('sps-lock', o); }
      on(fb, 'click', function () { toggle(true); });
      on(bd, 'click', function () { toggle(false); });
      $$('[data-sps-filters-close]', root).forEach(function (b) { on(b, 'click', function () { toggle(false); }); });
      wishSync();
    }
    function initRange(f) {
      var r = $('.sps-range', f); if (!r) return;
      var lo = r.querySelector('input[type=range][data-lo]'), hi = r.querySelector('input[type=range][data-hi]'), nlo = r.querySelector('input[type=number][data-lo]'), nhi = r.querySelector('input[type=number][data-hi]'), fill = r.querySelector('.sps-range__fill');
      if (!lo || !hi) return;
      var max = parseFloat(lo.max) || 1;
      function paint() { var a = parseFloat(lo.value), b = parseFloat(hi.value); if (a > b) { var t = a; a = b; b = t; } fill.style.left = (a / max * 100) + '%'; fill.style.right = (100 - b / max * 100) + '%'; }
      function fromRange() { var a = Math.min(parseFloat(lo.value), parseFloat(hi.value)), b = Math.max(parseFloat(lo.value), parseFloat(hi.value)); nlo.value = a > 0 ? a : ''; nhi.value = b < max ? b : ''; paint(); }
      function commit() { clearTimeout(timer); timer = setTimeout(function () { load(url(), true); }, 250); }
      ['input'].forEach(function (ev) { on(lo, ev, fromRange); on(hi, ev, fromRange); });
      on(lo, 'change', commit); on(hi, 'change', commit);
      on(nlo, 'input', function () { lo.value = nlo.value || 0; paint(); }); on(nhi, 'input', function () { hi.value = nhi.value || max; paint(); });
      paint();
    }
    on(window, 'popstate', function (e) { if (e.state && e.state.sps) load(window.location.href, false); });
    bind();
  }

  /* ---------- Empfehlungen ---------- */
  function initRecs(el) {
    var pid = el.getAttribute('data-product-id'); var sid = el.getAttribute('data-section-id'); var limit = el.getAttribute('data-limit') || 4; var intent = el.getAttribute('data-intent') || 'related';
    function load(int) {
      return fetch(SPS.routes.recommendations + '?section_id=' + sid + '&product_id=' + pid + '&limit=' + limit + '&intent=' + int, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = doc.querySelector('[data-sps-recs]');
          return fresh && fresh.innerHTML.trim() ? fresh.innerHTML : null;
        });
    }
    load(intent).then(function (html) {
      if (!html && intent === 'complementary') return load('related');
      return html;
    }).then(function (html) {
      if (html) { el.innerHTML = html; el.classList.add('is-loaded'); wishSync(); } else el.remove();
    }).catch(function () { el.remove(); });
  }

  /* ---------- Sticky-Kaufleiste ---------- */
  function initSticky() {
    var s = $('.sps-sticky'); if (!s) return;
    document.body.classList.add('sps-has-sticky');
    var main = $('[data-sps-atc]'); var btn = $('[data-sps-sticky-atc]', s);
    on(btn, 'click', function (e) { e.preventDefault(); if (main) main.click(); });
    if (!main) { s.classList.add('is-visible'); return; }
    var ticking = false;
    function check() { ticking = false; s.classList.toggle('is-visible', main.getBoundingClientRect().bottom < 0); }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    on(window, 'scroll', onScroll, { passive: true }); on(window, 'resize', onScroll); check();
  }

  /* ---------- Init ---------- */
  function init() {
    $$('.sps-search').forEach(initSearch);
    $$('.sps-tabs').forEach(initTabs);
    $$('.sps-gallery').forEach(initGallery);
    $$('form[data-sps-product-form]').forEach(initVariants);
    $$('[data-sps-collection]').forEach(initCollection);
    $$('[data-sps-recs][data-product-id]').forEach(initRecs);
    initSticky();
    wishSync();
    if ($('[data-sps-cart-count]')) Cart.fetch().catch(function () { });
    // Shopify Theme-Editor: Sections neu initialisieren
    document.addEventListener('shopify:section:load', function (e) {
      $$('.sps-search', e.target).forEach(initSearch); $$('.sps-tabs', e.target).forEach(initTabs); $$('.sps-gallery', e.target).forEach(initGallery); $$('[data-sps-collection]', e.target).forEach(initCollection); wishSync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
